/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespShopByModuleItem_item = {
    readonly title: string | null;
    readonly description: string | null;
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly imageHeight: string | null;
    readonly imageWidth: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
    };
    readonly " $refType": "HpRespShopByModuleItem_item";
};
export type HpRespShopByModuleItem_item$data = HpRespShopByModuleItem_item;
export type HpRespShopByModuleItem_item$key = {
    readonly " $data"?: HpRespShopByModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModuleItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespShopByModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
(node as any).hash = '6d5281e425e2cb0d040dc5b1dc3b9528';
export default node;
